module.exports = __webpack_public_path__ + "img/4.658e3cf3.png";